import type { User } from '@auth0/auth0-react';
import type { TeamMember } from './entity';
import { apiCall } from '@shared/entity';
import { axiosInstance } from '@libs/axios/axios';
import { VisitForm } from '../visits/entity';

export const teamApi = {
  get: () => '/api/team/',
  getMembers: (teamId: string) => `/api/team-members/${encodeURIComponent(teamId)}`,
  getMember: () => '/api/team-members/',
  inviteMember: () => '/api/team-members/invitation',
};

export const getTeamMember = async (): Promise<TeamMember> =>
  apiCall(async () => await axiosInstance.get(teamApi.getMember()), 'api.team.memberNotFound');

export const postInviteTeamMember = async (data: {
  email: string;
  consentId: string;
}): Promise<TeamMember> =>
  apiCall(async () => await axiosInstance.post(teamApi.inviteMember(), data), 'api.team.addError');

export const patchTeamMemberSkill = async (
  memberData: {
    canAccessStocks: boolean;
    canAccessClients: boolean;
    canAccessVisits: boolean;
  },
  teamId: string,
): Promise<VisitForm> =>
  apiCall(
    async () => await axiosInstance.patch(teamApi.getMembers(teamId), memberData),
    'api.team.permissionsError',
  );

export const getTeam = async (): Promise<User[]> =>
  apiCall(async () => await axiosInstance.get(teamApi.get()), 'api.team.notFound');

export const getTeamMembers = async (
  teamId: string,
): Promise<(TeamMember & { user: { name: string } })[]> =>
  apiCall(
    async () => await axiosInstance.get(teamApi.getMembers(teamId)),
    'api.team.membersNotFound',
  );

export const deleteTeamMember = async (id: string): Promise<TeamMember> =>
  apiCall(
    async () => await axiosInstance.delete(teamApi.getMember(), { data: { id } }),
    'api.team.deleteError',
  );
